import React, { Component } from "react";

import CmsCompany from "./CmsCompany";
import SideContentBlock from "../../../shared/sideContentBlock";
import SideContentInner from "../../../shared/sideContentInner";
import styles from "./../../Cms/cmsPage.module.scss";

class CmsCompanyPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <SideContentBlock>
        <SideContentInner>
          <div className={styles.cmsPage}>
            <CmsCompany />
          </div>
        </SideContentInner>
      </SideContentBlock>
    );
  }
}

export default CmsCompanyPage;
